import React from 'react';
import PageHero from '../components/PageHero';
import WhyCCC from '../components/WhyCCC';
import TherapyMeets from '../components/TherapyMeets';
import Testimonials from '../components/Testimonials';
import FinalCTA from '../components/FinalCTA';
import Seo from '../components/Seo';

export default function WhyCCCPage() {
  return (
    <>
      <Seo
        title="Why Chesapeake Counseling Center | The CCC Difference"
        description="Discover what makes Chesapeake Counseling Center a warm, trustworthy place for therapy — rapid appointments, experienced clinicians, and evidence-based care."
        path="/why-ccc"
      />
      <PageHero
        eyebrow="Why CCC"
        title="The CCC"
        highlight="Difference"
        subtitle="What makes Chesapeake Counseling Center a warm, trustworthy place to begin your healing."
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Why CCC' }]}
      />
      <WhyCCC />
      <TherapyMeets />
      <Testimonials />
      <FinalCTA />
    </>
  );
}
